
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import $$ from 'Dom7';
import actions from '../js/actions.js';
import URLS from '../js/Urls.js';
import '../css/notifications.css';
export default {
  data: function () {
    return {
      Notifications: {},
      News: {},
      newsActive: '',
      loginResult: actions.LoginGetResult()
    };
  },
  methods: {
    Read: async function (noticationid) {
      await actions.ReadNotification(noticationid, 0);
    },
    toogleDiv: async function (id) {
      $("#" + id).slideToggle();
    },
    Dissmiss: async function (noticationid) {
      var self = this;
      await actions.ReadNotification(noticationid, 1);
    }
  },
  on: {
    pageInit: async function (e, page) {
      app.f7.preloader.show();
      var loginResult = actions.LoginGetResult();

      if (loginResult?.DisableNotifications) {
        this.$setState({
          newsActive: "tab-active"
        });
      }

      $(document).on("click", ".notif-item", function () {
        let action = $(this).data("action");

        if (action && action.startsWith("CalGoToMainResCard")) {
          let match = action.match(/\((.*?)\)/);

          if (match && match[1]) {
            let params = match[1].split(",");
            let ReservationID = params[0]?.trim();
            app.f7.preloader.show();
            localStorage.setItem("ReservationID", JSON.stringify(ReservationID));
            app.f7.views.main.router.navigate("/reservation-info/", {
              transition: "f7-dive"
            });
          }
        }
      });
      $(".searchbar-enable").on("click", async function (e) {
        app.f7.views.main.router.navigate('/search-reservation/', {
          transition: 'f7-dive'
        });
      });
      var Notificationslist = await actions.GetNotificationsData();
      console.log(Notificationslist);
      var Newslist = await actions.GetNews();
      var keys = Object.keys(Notificationslist);

      for (let i = 0; i < keys.length; i++) {
        let thisKey = keys[i];

        if (thisKey === "NotificationsLast7" || thisKey === "NotificationsLast30" || thisKey === "NotificationsToday" || thisKey === "NotificationsYesterday") {
          if (Notificationslist[thisKey] && Notificationslist[thisKey].length > 0) {
            Notificationslist[thisKey] = Notificationslist[thisKey].map(function (item) {
              item.NotificationText = item?.NotificationText?.replace(" PMS ", "");
              return item;
            });
          }
        }
      }

      this.$setState({
        Notifications: Notificationslist,
        News: Newslist
      });

      window.onload = function () {
        app.f7.preloader.hide();
      };
    }
  },
  id: '3b61d35838',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class="page tabbar-labels-fixed" data-page=tabbar-labels data-name=Notifications><!-- Top Navbar --><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a class="link back"><i class="icon icon-back"></i></a></div><div class=title>';
      r += Template7Helpers.t.call(ctx_1, 'notifications', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=right><a class="link icon-only searchbar-enable"><i class="icon f7-icons if-not-md">search</i> <i class="icon material-icons md-only">search</i></a></div><div class=subnavbar style="background-color: #222933;"><div class=subnavbar-inner><div class="segmented segmented-strong" style=background-color:#40454cb8>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginResult?.DisableNotifications, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <a class="button tab-link tab-link-active" href=#notifications-tab>';
          r += Template7Helpers.t.call(ctx_2, 'notifications', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</a> <a class="button tab-link" href=#news-tab>';
          r += Template7Helpers.t.call(ctx_2, 'news', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</a> ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' <a class="button tab-link tab-link-active" href=#news-tab>';
          r += Template7Helpers.t.call(ctx_2, 'news', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</a> ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' <span class=segmented-highlight></span></div><!-- <a class="tab-link mytabcolor tab-link-active" href="#notifications-tab">';
      r += Template7Helpers.t.call(ctx_1, 'notifications', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</a>\r\n            <a class="tab-link mytabcolor" href="#news-tab">';
      r += Template7Helpers.t.call(ctx_1, 'news', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</a> --></div></div></div></div><div class="page-content activitypage"><div class=tabs><!--All  reservations--> ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginResult?.DisableNotifications, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="tab page-content tab-active" id=notifications-tab><div class=list><!-- ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Notifications.CommunicatorNotification, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\r\n            <div class="swipeout-content">\r\n              <div class="card card-outline">\r\n                <div class="card-content card-content-padding reservationcard">\r\n                  <div class="row ';
              r += c(ctx_3.NotificationClass, ctx_3);
              r += '">\r\n                    <div>\r\n                      <div class="NotificationBoxContent InNotifTitle"\r\n                        style="flex-direction: column;align-items: baseline;">\r\n                        <div style="display: flex;">\r\n                          <div class="NotificationBoxIcon"\r\n                            style="width: 50px !important; font-size: 30px; color: #4a81b1; ">\r\n                            <i class="material-icons">\r\n                              mail\r\n                            </i>\r\n                          </div>\r\n                          <span style="color: #4a81b1; width: 100%; display: inline-block; ">Communicator</span>\r\n                        </div>\r\n                        <span style="width:100%;display:inline-block;padding-top: 2px;"><span style="color:#4693ad;">You\r\n                            have ';
              r += c(ctx_3.InvoicesCountF, ctx_3);
              r += ' </span> new\r\n                          messages</span>\r\n                        <a href="/communicator/" class="NotMoreBtn" class="NotsFilterBoxBtn">More <i\r\n                            style="margin-top: 2px;" class="material-icons">\r\n                            chevron_right\r\n                          </i></a>\r\n                      </div>\r\n                      <div class="NotificationBoxDate" style="align-items: baseline;">\r\n                        <span class="NotificationDateS">';
              r += Template7Helpers.FormatDate.call(ctx_3, 2, ctx_3.NotificationDateStr, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' --></div><div class="block-title activity" @click="toogleDiv(\'notificationsToday\')">';
          r += Template7Helpers.t.call(ctx_2, 'today', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class=list><ul><div id=notificationsToday>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Notifications.NotificationsToday, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<li class=swipeout><div class=swipeout-content><div class="card card-outline"><div class="card-content card-content-padding reservationcard notif-item" data-action=';
              r += c(ctx_3.ActionBtn, ctx_3);
              r += '><div class="row ';
              r += c(ctx_3.NotificationClass, ctx_3);
              r += '">';
              r += c(ctx_3.NotificationText, ctx_3);
              r += '</div><span class=notificationDate>';
              r += Template7Helpers.FormatDate.call(ctx_3, 2, ctx_3.NotificationDateStr, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div></div></div><!--End swipeout content--><div class=swipeout-actions-right>';
              r += Template7Helpers.if.call(ctx_3, ctx_3.IsRead, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <a href=# class="color-orange swipeout-close" @click=Read(';
                  r += c(ctx_4.NotificationID, ctx_4);
                  r += ');>Read</a> ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '<!-- <a href="#" class="swipeout-delete swipeout-overswipe" @click="Dissmiss(';
              r += c(ctx_3.NotificationID, ctx_3);
              r += ');">Dismiss</a> --><!-- <a href="#" data-confirm="Are you sure you want to delete this item?"\r\n                      class="swipeout-delete swipeout-overswipe">Delete</a> --></div></li>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div></ul></div><!--Yesterday--><div class="block-title activity" @click="toogleDiv(\'notificationsYesterday\')">';
          r += Template7Helpers.t.call(ctx_2, 'yesterday', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class=list><ul><div id=notificationsYesterday>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Notifications.NotificationsYesterday, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<li class=swipeout><div class=swipeout-content><div class="card card-outline"><div class="card-content card-content-padding reservationcard notif-item" data-action=';
              r += c(ctx_3.ActionBtn, ctx_3);
              r += '><div class="row ';
              r += c(ctx_3.NotificationClass, ctx_3);
              r += '">';
              r += c(ctx_3.NotificationText, ctx_3);
              r += '</div><span class=notificationDate>';
              r += Template7Helpers.FormatDate.call(ctx_3, 2, ctx_3.NotificationDateStr, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div></div></div><!--End swipeout content--><div class=swipeout-actions-right>';
              r += Template7Helpers.if.call(ctx_3, ctx_3.IsRead, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <a href=# class="color-orange swipeout-close" @click=Read(';
                  r += c(ctx_4.NotificationID, ctx_4);
                  r += ');>Read</a> ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '<!-- <a href="#" class="swipeout-delete swipeout-overswipe" @click="Dissmiss(';
              r += c(ctx_3.NotificationID, ctx_3);
              r += ');">Dismiss</a> --><!-- <a href="#" data-confirm="Are you sure you want to delete this item?"\r\n                  class="swipeout-delete swipeout-overswipe">Delete</a> --></div></li>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div></ul></div><!--Before 7 days--><div class="block-title activity" @click="toogleDiv(\'notificationsLastWeek\')">';
          r += Template7Helpers.t.call(ctx_2, 'sevendaysbefore', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class=list><ul><div id=notificationsLastWeek>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Notifications.NotificationsLast7, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<li class=swipeout><div class=swipeout-content><div class="card card-outline"><div class="card-content card-content-padding reservationcard notif-item" data-action=';
              r += c(ctx_3.ActionBtn, ctx_3);
              r += '><div class="row ';
              r += c(ctx_3.NotificationClass, ctx_3);
              r += '">';
              r += c(ctx_3.NotificationText, ctx_3);
              r += '</div><span class=notificationDate>';
              r += Template7Helpers.FormatDate.call(ctx_3, 2, ctx_3.NotificationDateStr, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div></div></div><!--End swipeout content--><div class=swipeout-actions-right>';
              r += Template7Helpers.if.call(ctx_3, ctx_3.IsRead, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <a href=# class="color-orange swipeout-close" @click=Read(';
                  r += c(ctx_4.NotificationID, ctx_4);
                  r += ');>Read</a> ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '<!-- <a href="#" class="swipeout-delete swipeout-overswipe" @click="Dissmiss(';
              r += c(ctx_3.NotificationID, ctx_3);
              r += ');">Dismiss</a> --><!-- <a href="#" data-confirm="Are you sure you want to delete this item?"\r\n                      class="swipeout-delete swipeout-overswipe">Delete</a> --></div></li>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div></ul></div><!--Before 30 days--><div class="block-title activity" @click="toogleDiv(\'notificationsLastMonth\')">';
          r += Template7Helpers.t.call(ctx_2, 'thirtydaysbefore', {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class=list><ul><div id=notificationsLastMonth>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Notifications.NotificationsLast30, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<li class=swipeout><div class=swipeout-content><div class="card card-outline"><div class="card-content card-content-padding reservationcard notif-item" data-action=';
              r += c(ctx_3.ActionBtn, ctx_3);
              r += '><div class="row ';
              r += c(ctx_3.NotificationClass, ctx_3);
              r += '">';
              r += c(ctx_3.NotificationText, ctx_3);
              r += '</div><span class=notificationDate>';
              r += Template7Helpers.FormatDate.call(ctx_3, 2, ctx_3.NotificationDateStr, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div></div></div><!--End swipeout content--><div class=swipeout-actions-right>';
              r += Template7Helpers.if.call(ctx_3, ctx_3.IsRead, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <a href=# class="color-orange swipeout-close" @click=Read(';
                  r += c(ctx_4.NotificationID, ctx_4);
                  r += ');>Read</a> ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '<!-- <a href="#" class="swipeout-delete swipeout-overswipe" @click="Dissmiss(';
              r += c(ctx_3.NotificationID, ctx_3);
              r += ');">Dismiss</a> --><!-- <a href="#" data-confirm="Are you sure you want to delete this item?"\r\n                      class="swipeout-delete swipeout-overswipe">Delete</a> --></div></li>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div></ul></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<div class="tab page-content ';
      r += c(ctx_1.newsActive, ctx_1);
      r += '" id=news-tab><div class=list><ul>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.News, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li class=""><div class="card card-outline"><a style=display:block; class="link external" href=';
          r += c(ctx_2.NotificationLink, ctx_2);
          r += '><div class="card-content card-content-padding reservationcard"><div class=row style=padding:5px;>';
          r += Template7Helpers.FormatDate.call(ctx_2, 2, ctx_2.NotificationDateStr, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class=row style="color: #1264A3;padding:5px;">';
          r += c(ctx_2.NotificationTitle, ctx_2);
          r += '</div><div class="row WhatsNewText" style=padding:5px;>';
          r += c(ctx_2.NotificationText, ctx_2);
          r += '</div><div class=WhatsNewLink>Διαβάστε περισσότερα &gt;</div></div></a></div></li>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .InNotifTitle {
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .NotMoreBtn {
    font-weight: 600;
    display: flex;
    background: #f3f3f3;
    border-radius: 3px;
    padding: 5px 10px;
    margin: 5px 0;
    border: 1px solid #a39d9d;
  }
`,
  styleScoped: false
};
    